<template>
  <transition name="wrapper-transition" enter-active-class="animated slideInUp"
              leave-active-class="animated slideOutDown" appear>
    <div class="row no-gutters popup-wrapper" v-if="allowNewsletterWidgetPopup">
      <div class="close-icon-box d-flex align-items-center" @click="closeNewsletter">
        <svg-cancel-icon class="icon mx-auto" width="100%" height="100%"></svg-cancel-icon>
      </div>
      <div class="col-12">
        <slot name="content"></slot>
      </div>
    </div>
  </transition>
</template>
<script>
  import { mapActions, mapState } from 'vuex'
  import SvgCancelIcon from 'static/svg/icon_cancel.svg'

  export default {
    components: {
      SvgCancelIcon,
    },
    computed: {
      ...mapState(['allowNewsletterWidgetPopup']),
    },
    data() {
      return {
        closePopUp: false,
      }
    },
    methods: {
      ...mapActions([
        'toggleNewsletter',
        'enableNewsletterWidgetPopup',
      ]),
      closeNewsletter() {
        this.toggleNewsletter()
        this.enableNewsletterWidgetPopup(false)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .popup-wrapper {
    position: relative;
    .close-icon-box {
      z-index: 2;
      position: absolute;
      right: 0;
      top: rem-calc(- 30);
      width: rem-calc(30);
      height: rem-calc(30);
      background: $manatee2;
      .icon {
        width: rem-calc(15);
        height: rem-calc(15);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// PopUpWrapper.vue?73ee6f7e